(() => {
  const root = document.querySelector('[data-msp-pipe]');
  if (!root) return;

  const grid = root.querySelector('[data-pipe-grid]');
  const results = root.querySelector('[data-pipe-results]');
  const curated = root.querySelector('[data-pipe-curated]');
  const count = root.querySelector('[data-pipe-result-count]');
  const activeFilters = root.querySelector('[data-pipe-active-filters]');
  const reset = root.querySelector('[data-pipe-reset]');
  const sort = root.querySelector('[data-pipe-sort]');
  const more = root.querySelector('[data-pipe-more]');
  const empty = root.querySelector('[data-pipe-empty]');
  const groups = [...root.querySelectorAll('[data-pipe-filter-group]')];
  let cards = [...grid.querySelectorAll('[data-pipe-product]')];
  let limit = 12;
  let resultsOpen = false;

  const activeFor = (group) => [...group.querySelectorAll('[data-pipe-filter][aria-pressed="true"]')];
  const closeGroup = (group, restoreFocus = false) => {
    const toggle = group?.querySelector('[data-pipe-group-toggle]');
    const panel = toggle?.nextElementSibling;
    if (!toggle || !panel) return;
    const wasOpen = toggle.getAttribute('aria-expanded') === 'true';
    toggle.setAttribute('aria-expanded', 'false');
    panel.hidden = true;
    if (restoreFocus && wasOpen) toggle.focus({ preventScroll: true });
  };
  const closeGroups = (except = null) => groups.forEach((group) => {
    if (group !== except) closeGroup(group);
  });

  const componentMatches = (card, button) => {
    const values = (button.dataset.pipeMatch || button.dataset.pipeFilter).split(',');
    return values.includes(card.dataset.component);
  };
  const matchesButton = (card, group, button) => {
    const value = button.dataset.pipeFilter;
    if (group === 'kind') return card.dataset.kind === value;
    if (group === 'diameter') return card.dataset.diameters.includes(`|${value}|`);
    if (group === 'component') return componentMatches(card, button);
    return true;
  };
  const matchedCards = () => {
    const activeGroups = groups
      .map((group) => ({ name: group.dataset.pipeFilterGroup, buttons: activeFor(group) }))
      .filter(({ buttons }) => buttons.length);
    return {
      activeGroups,
      matches: cards.filter((card) => activeGroups.every(({ name, buttons }) => buttons.some((button) => matchesButton(card, name, button))))
    };
  };

  const renderActiveFilters = (activeGroups) => {
    activeFilters.replaceChildren(...activeGroups.flatMap(({ buttons }) => buttons.map((button) => {
      const chip = document.createElement('button');
      chip.type = 'button';
      chip.textContent = `${button.dataset.pipeChipLabel || button.textContent.trim()} ×`;
      chip.addEventListener('click', () => {
        button.setAttribute('aria-pressed', 'false');
        limit = 12;
        apply();
      });
      return chip;
    })));
  };

  const sortCards = () => {
    const mode = sort.value;
    [...cards].sort((a, b) => {
      if (mode === 'price-asc') return Number(a.dataset.price) - Number(b.dataset.price);
      if (mode === 'price-desc') return Number(b.dataset.price) - Number(a.dataset.price);
      return Number(a.dataset.index) - Number(b.dataset.index);
    }).forEach((card) => grid.append(card));
  };

  const apply = () => {
    const { activeGroups, matches } = matchedCards();
    const hasFilters = activeGroups.length > 0;
    const shouldShowResults = resultsOpen || hasFilters;
    let visible = 0;
    cards.forEach((card) => {
      const isMatch = matches.includes(card);
      const show = shouldShowResults && isMatch && visible < limit;
      card.hidden = !show;
      if (show) visible += 1;
    });
    results.hidden = !shouldShowResults;
    curated.hidden = shouldShowResults;
    empty.hidden = !shouldShowResults || matches.length !== 0;
    more.hidden = !shouldShowResults || visible >= matches.length;
    reset.disabled = !hasFilters && !resultsOpen;
    count.textContent = shouldShowResults
      ? `${matches.length} passende${matches.length === 1 ? 's' : ''} Produkt${matches.length === 1 ? '' : 'e'}${matches.length > visible ? ` – ${visible} angezeigt` : ''}`
      : `${root.dataset.collectionCount} Produkte – wählen Sie Filter oder entdecken Sie unsere Empfehlungen.`;
    renderActiveFilters(activeGroups);
  };

  const refreshAvailability = () => {
    groups.forEach((group) => {
      const name = group.dataset.pipeFilterGroup;
      group.querySelectorAll('[data-pipe-filter]').forEach((button) => {
        button.hidden = !cards.some((card) => matchesButton(card, name, button));
      });
    });
  };

  const loadRemainingProducts = async () => {
    const pages = Number(root.dataset.pages || 1);
    if (pages < 2) return;
    const sectionId = root.dataset.sectionId;
    const requests = [];
    for (let page = 2; page <= pages; page += 1) {
      const url = new URL(window.location.href);
      url.searchParams.set('page', String(page));
      url.searchParams.set('section_id', sectionId);
      requests.push(fetch(url, { credentials: 'same-origin' }).then((response) => {
        if (!response.ok) throw new Error(`Section response ${response.status}`);
        return response.text();
      }));
    }
    try {
      const pagesHtml = await Promise.all(requests);
      const handles = new Set(cards.map((card) => card.dataset.handle));
      pagesHtml.forEach((html) => {
        const documentPage = new DOMParser().parseFromString(html, 'text/html');
        documentPage.querySelectorAll('[data-pipe-grid] [data-pipe-product]').forEach((card) => {
          if (handles.has(card.dataset.handle)) return;
          handles.add(card.dataset.handle);
          card.dataset.index = String(cards.length);
          card.hidden = true;
          grid.append(card);
          cards.push(card);
        });
      });
      sortCards();
      refreshAvailability();
      apply();
      root.dataset.productsLoaded = String(cards.length);
    } catch (_error) {
      root.dataset.productsLoaded = String(cards.length);
    }
  };

  root.addEventListener('click', (event) => {
    const filter = event.target.closest('[data-pipe-filter]');
    if (filter) {
      filter.setAttribute('aria-pressed', String(filter.getAttribute('aria-pressed') !== 'true'));
      resultsOpen = true;
      limit = 12;
      closeGroup(filter.closest('[data-pipe-filter-group]'), true);
      apply();
      return;
    }
    const toggle = event.target.closest('[data-pipe-group-toggle]');
    if (toggle) {
      const group = toggle.closest('[data-pipe-filter-group]');
      const open = toggle.getAttribute('aria-expanded') !== 'true';
      if (open) closeGroups(group);
      toggle.setAttribute('aria-expanded', String(open));
      toggle.nextElementSibling.hidden = !open;
      return;
    }
    const tab = event.target.closest('[data-pipe-tab]');
    if (tab) {
      root.querySelectorAll('[data-pipe-tab]').forEach((item) => item.setAttribute('aria-selected', String(item === tab)));
      root.querySelectorAll('[data-pipe-panel]').forEach((panel) => { panel.hidden = panel.dataset.pipePanel !== tab.dataset.pipeTab; });
      return;
    }
    if (event.target.closest('[data-pipe-show-all]')) {
      resultsOpen = true;
      limit = 12;
      apply();
      results.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  });

  document.addEventListener('click', (event) => {
    if (!(event.target instanceof Element) || !event.target.closest('[data-pipe-filter-group]')) closeGroups();
  });
  document.addEventListener('keydown', (event) => {
    if (event.key !== 'Escape') return;
    const openGroup = groups.find((group) => group.querySelector('[data-pipe-group-toggle]')?.getAttribute('aria-expanded') === 'true');
    if (openGroup) closeGroup(openGroup, true);
  });
  reset.addEventListener('click', () => {
    root.querySelectorAll('[data-pipe-filter][aria-pressed="true"]').forEach((button) => button.setAttribute('aria-pressed', 'false'));
    resultsOpen = false;
    limit = 12;
    sort.value = 'recommended';
    sortCards();
    apply();
  });
  sort.addEventListener('change', () => { sortCards(); apply(); });
  more.addEventListener('click', () => { limit += 12; apply(); });

  cards.forEach((card) => { card.hidden = true; });
  refreshAvailability();
  sortCards();
  apply();
  loadRemainingProducts();
})();
